$(document).on('click', 'form#multiple_users_confirmation button[type=submit]', function (event) {
  $('#multiple_users_confirmation_modal').modal('hide');
});

